import * as React from 'react';
import { Image, StyleSheet, View, ScrollView } from 'react-native'
import logoApp from './LogoApp.png';
import { Provider as PaperProvider, Text, Divider, DefaultTheme } from 'react-native-paper';
import { whiteColor, blackColor, greyColor } from '../src/common/colors';
import Button from './common/Button';
import routes from '../src/routing/routes';
import { actionCreators } from './containers/LogIn/action';
import { connect } from 'react-redux';
import appJSON from '../app.json';
import sizeOfLogo  from './common/sizeOfLogo';
import { useSafeAreaInsets } from "react-native-safe-area-context";
import t from './translations';

const theme = {
  ...DefaultTheme,
  roundness: 0,
  colors: {
    ...DefaultTheme.colors,
    primary: blackColor,
    background: whiteColor,
  },
};

function App(props) {
  const [isPressedSignInButton, setSignInButton] = React.useState(false);
  const [isRegistrationFormButton, setRegistrationFormButton] = React.useState(false);

  React.useEffect(()=>{
    props.rehydrateAuth({redirect: props.navigation.navigate});
  }, [])

  const onPressRegistrationForm = () => {
    setRegistrationFormButton(true)
  
    setTimeout(()=>setRegistrationFormButton(false), 1000)
  }
  const insets = useSafeAreaInsets();

  return (
    <PaperProvider theme={theme}>
       <ScrollView contentContainerStyle={{...styles.container, paddingTop: insets.top}}>
      <View style={styles.container}>
        <Image source={logoApp} style={styles.logo} />
        <Text style={styles.description}>{t('main_page_slogan_1')}</Text>
        <Text style={styles.descriptiontwo}> {t('main_page_slogan_2')} </Text>
        <Divider style={styles.divider} />
        <Button onPress={()=>props.navigation.navigate(routes.SignIn)} value={t('main_page_sign_in')} />
        <View style={styles.linecontainer}>
          <Divider style={styles.breakline}>
          <Text style={styles.or}>{t('main_page_or')}</Text>
          </Divider>
        </View>
        <Button onPress={()=>props.navigation.navigate(routes.RegistrationForm)} value={t('main_page_create_account')} />

        <Text style={styles.version}>Copyright © Loriini Tribes (v.{appJSON.expo.version}) - 2021</Text>
        <Text style={styles.slogan}> powered by passion, made for you with {"<3"} </Text>

      </View>
      </ScrollView>
      {/* <FooterMenu {...props} /> */}
    </PaperProvider>
  );
}

export default connect(null, actionCreators)(App);

const styles = StyleSheet.create({
  description: {
    textAlign: 'center',
    fontSize: 16,
    letterSpacing: 1,
    paddingTop: 20,
  },
  descriptiontwo: {
    textAlign: 'center',
    fontSize: 16,
    letterSpacing: 1,
    paddingBottom: 20,
  },
  logo: {
    marginTop: 0,
    // flex: 1,
    width: 300,
    height: sizeOfLogo()/3,
    resizeMode: 'contain',
    justifyContent: 'center',
    alignItems: 'center',
  },

  container: {
    alignItems: 'center',
    paddingTop: 10,
    marginBottom: 30,
    backgroundColor: whiteColor,
    paddingBottom: 10,
  },
  textButton: {
  },
  divider: {
    height: 10,
    backgroundColor: whiteColor,
  },
  button: {
    borderWidth: 3,
    width: 273,
    borderColor: blackColor,
    height: 48,
  },
  linecontainer: {
    backgroundColor: whiteColor,
    width: 280,
    paddingTop: 20,
    paddingBottom: 20,
  },
  breakline: {
    height: 1,
    backgroundColor: greyColor,
  },
  or: {
    textAlign: 'center',
    alignSelf: 'center',
    width: 45,
    marginTop: -6,
    height: 10,
    color: greyColor,
    fontSize: 10,
    letterSpacing: 1.25,
    backgroundColor: whiteColor,
  },
  version: {
    textAlign: 'center',
    alignSelf: 'center',
    fontSize: 10,
    color: greyColor,
    marginTop: 20
  },
  slogan: {
    textAlign: 'center',
    alignSelf: 'center',
    fontSize: 10,
    color: greyColor,
    marginTop: 5
  }
});

